module.exports = __webpack_public_path__ + "static/img/ALFA ROMEO.435d1e3.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/logos_vehicules/ALFA ROMEO.png
// module id = oAQH
// module chunks = 1